<H2>Admin menu</H2>
<nav class="admin-menu">
  <a mat-menu-item routerLink="/admin" routerLinkActive="active-link">Terug naar dashboard</a>
  <a mat-menu-item routerLink="/admin/technicalpage" routerLinkActive="active-link">Technische pagina</a>
  <H3>Documenten</H3>
  <a mat-menu-item routerLink="/admin/documents" routerLinkActive="active-link">Documenten</a>
  <H3>Alpacas</H3>
  <a mat-menu-item routerLink="/admin/alpacas" routerLinkActive="active-link">Alpacas</a>
  <a mat-menu-item routerLink="/admin/alpaca-fleeces" routerLinkActive="active-link">Alpaca fleeces</a>
  <a mat-menu-item routerLink="/admin/alpaca-showresults" routerLinkActive="active-link">Show resultaten</a>
  <a mat-menu-item routerLink="/admin/alpacashows" routerLinkActive="active-link">Alpacashows</a>
  <h3>Links</h3>
  <a mat-menu-item routerLink="/admin/links" routerLinkActive="active-link">Links</a>
  <a mat-menu-item routerLink="/admin/linktypes" routerLinkActive="active-link">Link categorieën</a>
  <h3>Infopages</h3>
  <a mat-menu-item routerLink="/admin/infopages" routerLinkActive="active-link">Infopages</a>
  <a mat-menu-item routerLink="/admin/infopage-categories" routerLinkActive="active-link">Infopage categorieën</a>
  <a mat-menu-item routerLink="/admin/infopage-tags" routerLinkActive="active-link">Infopage tags</a>

</nav>
